<!-- Navigation Dropdown with Context -->
<div class="navigation-container">

  <!-- Context Label -->
  <div class="context-section" *ngIf="contextTitle">
    <span class="context-label">{{ contextTitle | translate }}</span>
    <mat-icon class="context-arrow">chevron_right</mat-icon>
  </div>

  <!-- Main Dropdown -->
  <div class="navigation-dropdown" [class.dropdown-open]="isDropdownOpen">
    <button
      class="dropdown-trigger"
      type="button"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isDropdownOpen">
      <span class="dropdown-trigger-text">
        {{ getCurrentItemLabel() | translate }}
      </span>
      <mat-icon class="dropdown-arrow" [class.dropdown-arrow-up]="isDropdownOpen">
        expand_more
      </mat-icon>
    </button>

    <div
      class="dropdown-panel"
      [@slideDown]="isDropdownOpen ? 'open' : 'closed'"
      (click)="$event.stopPropagation()">
      <div class="dropdown-content" *ngIf="isDropdownOpen">
        <button
          *ngFor="let item of getVisibleItems(); trackBy: trackByItemId"
          class="dropdown-item"
          type="button"
          [ngClass]="{'dropdown-item--active': isActive(item), 'dropdown-item--disabled': item.disabled}"
          [disabled]="item.disabled"
          (click)="onItemClick(item, $event)">
          <mat-icon *ngIf="item.icon" class="dropdown-item-icon">{{ item.icon }}</mat-icon>
          <span class="dropdown-item-text">{{ item.label | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Second Level Dropdown (Conditional) -->
  <ng-container *ngFor="let item of items; trackBy: trackByItemId"> <div class="flex items-center" *ngIf="isActive(item) && hasChildren(item)">
    <mat-icon class="context-arrow mx-1">chevron_right</mat-icon>

    <div class="navigation-dropdown" [class.dropdown-open]="isSubMenuOpen">
      <button
        class="dropdown-trigger"
        type="button"
        [matMenuTriggerFor]="dynamicSubMenu"
        [matMenuTriggerData]="{ item: item }"
        (menuOpened)="toggleSubMenu(true)"
        (menuClosed)="toggleSubMenu(false)">
        <span class="dropdown-trigger-text">
          {{ getActiveChildLabel(item) | translate }}
        </span>
        <mat-icon class="dropdown-arrow" [class.dropdown-arrow-up]="isSubMenuOpen">
          expand_more
        </mat-icon>
      </button>
    </div>
  </div>
  </ng-container>

  <mat-menu #dynamicSubMenu="matMenu" class="navigation-mat-menu">
    <ng-template matMenuContent let-item="item">
      <button
        mat-menu-item
        *ngFor="let child of getVisibleChildren(item)"
        [class.active]="router.url.includes(child.url || child.route || '')"
        (click)="onChildClick(item, child, $event)"
        [disabled]="router.url.includes(child.url || child.route || '')">
        <mat-icon *ngIf="child.icon">{{ child.icon }}</mat-icon>
        <span>{{ child.label | translate }}</span>
      </button>
    </ng-template>
  </mat-menu>
</div>

<!-- Backdrop para cerrar dropdown -->
<div
  class="dropdown-backdrop"
  *ngIf="isDropdownOpen"
  (click)="closeDropdown()">
</div>
